module.exports = __webpack_public_path__ + "img/sfondo-spaghetti-soia.b4431609.png";